import React, { useState,useEffect,useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Barcode from "react-barcode";
import axios from '../../plugins/axios'
import "./A4.scss";

const BarcodeForm = () => {
    const [searchParams] = useSearchParams();
    const isFirstRender = useRef(true);
    const [barcodeDatas, setBarcodeDatas] = useState([]);
    const [queryParams, setQueryParams] = useState({})
    const [pageCount, setPageCount] = useState(null)
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isPageReady, setIsPageReady] = useState(false);

    // Device 정보 가져와서 Barcode 생성
    const getBarcodeData = async() => {
        try{
            const res = await axios.get(`/devices`,{params : {deviceIds : queryParams?.devices?.join(',') || []}});
            console.log('getBarcodeData', res);
            
            let isDischarge = queryParams.discharge == 'true' ? [{id: 'Discharge', bedNumber : 'Discharge', serial : 'Discharge'}] : [];            
            
            const filteredBarcodeDatas = res?.data.content?.map(item => ({
                id: item.id,
                serial: item.serial,
                bedNumber: item.bedNumber
            }));            

            // isDIscharge가 []가 아니면 filteredBarcodeDatas 앞에 추가
            setBarcodeDatas([...isDischarge, ...filteredBarcodeDatas]);
            return true;
        }
        catch(err){
            console.warn(err);
            return false;
        }
    }

    // 프린터 함수
    const handlePrint = () => {
        console.log('프린트 시작');
        
        // 클래스 제거 후 다시 추가 (리프레시 효과)
        document.documentElement.classList.remove("waveform-active");
        document.body.classList.remove("waveform-active");
        
        setTimeout(() => {
            document.documentElement.classList.add("waveform-active");
            document.body.classList.add("waveform-active");
            
            setTimeout(() => {
                console.log('페이지 수:', document.querySelectorAll('.a4-page').length);
                window.print();
            }, 500);
        }, 100);
    };

    useEffect(() => {         

        setQueryParams({
            discharge : searchParams?.get('discharge') || false,
            devices : JSON.parse(searchParams?.get('devices')) || []
        });  

        const style = document.createElement("style");
            style.innerHTML = `
            @page {
                size: 2480px 3508px;
                margin: 0;
            }
            `;
        document.head.appendChild(style);

        // 스타일 클래스 추가
        document.documentElement.classList.add("waveform-active");
        document.body.classList.add("waveform-active");        

        return () => {
            document.documentElement.classList.remove("waveform-active");
            document.body.classList.remove("waveform-active");
            document.head.removeChild(style); // 라우트 빠져나갈 때 제거
        };
    }, []);

    useEffect(() => {
        if(isFirstRender.current){
            isFirstRender.current = false;
            return;
        }

        console.log('queryParams : ', queryParams);
        getBarcodeData(); //Device & Patient정보 가져오기.
    }, [queryParams])    

    useEffect(() => {
        if(barcodeDatas){
            const loadAllData = async () => {                
                
                try {
                    // 모든 비동기 작업을 병렬로 실행
                    const [barcodeData] = await Promise.all([
                        getBarcodeData() 
                    ]);

                    if (barcodeData) {                        
                        setPageCount(Math.ceil(barcodeDatas.length / 40)); //40개씩 한페이지에 출력
                        setIsDataLoaded(true);
                    } else {
                        console.error('데이터 로딩 실패');
                    }
                } catch (error) {
                    console.error('데이터 로드 중 에러:', error);
                }
            };
            loadAllData();

        }
    }, [barcodeDatas])
    
    useEffect(() => {
        if (isDataLoaded) {
            // DOM 렌더링 및 Canvas 그리기 완료를 위한 충분한 대기 시간
            const renderTimer = setTimeout(() => {
                //console.log('페이지 렌더링 완료');
                setIsPageReady(true);
            }, 500); // Canvas 렌더링을 고려한 여유 시간

            return () => clearTimeout(renderTimer);
        }
    }, [isDataLoaded]);
    
    //페이지 준비 완료 시 자동 프린트
    useEffect(() => {
        if (isPageReady) {
            // URL 파라미터로 자동 프린트 제어
            const urlParams = new URLSearchParams(window.location.search);
            const autoPrint = urlParams.get('autoPrint');
            const delay = parseInt(urlParams.get('delay')) || 3000;
            
            if (autoPrint === 'true' || autoPrint === null) { // 기본값은 자동 프린트
                setTimeout(() => {
                    handlePrint(); // 자동 프린트 잠시 스탑
                }, delay);
            }
        }
    }, [isPageReady]);

    //인쇄 하거나 취소하고 창 꺼지기
    window.onafterprint = () => {
        setTimeout( () => {
            window.close();
        },1000)
    };

    const TitleFont = 'text-black font-medium text-[48px] leading-[110%] font-pretendard';

    return (
        <div className="document-container bg-gray-100 p-20 font-sans min-h-screen">
            {
                pageCount && Array.from({length : pageCount}).map((_, pageIndex) => {
                    return (
                        <div className="a4-page mx-auto bg-white shadow-lg relative box-border">
                            <div className="w-full h-full flex flex-col px-[146px] pt-[140px] pb-[66px]">
                                {/* Header */}
                                <div className={`${TitleFont} w-full flex items-center justify-start mb-[24px] border-b border-[#5E5E5E] pb-[24px]`}>
                                    <h1 className="mr-[80px] ">
                                        <span>Barcode</span>                            
                                    </h1>                        
                                </div>
                                
                                <div className="w-full flex flex-wrap justify-start gap-x-[36px] gap-y-[36px]">
                                    {
                                        barcodeDatas && barcodeDatas.filter((data, index) => {
                                            const startIndex = pageIndex * 40;
                                            const endIndex = startIndex + 40;
                                            return index >= startIndex && index < endIndex;
                                        }).map((data, rowIndex) => {
                                            return (
                                                <div className='w-[515px] bg-[#fff] flex flex-col justify-center items-center px-[24px] py-[30px] rounded-[24px]' key={`barcode-${pageIndex}-${rowIndex}`}>
                                                    <p className='text-[#000] text-center font-pretendard text-[48px] font-medium leading-[110%] mb-[24px]'>{data.bedNumber == 'Discharge' ? data.bedNumber : `BED-${data.bedNumber}`}</p>
                                                    <div className='mb-[12px]'>
                                                        <Barcode value={data.serial} format="CODE128" width={2} height={96} displayValue={false} margin={0} />
                                                    </div>
                                                    <p className='text-[#000] text-center font-pretendard text-[33px] font-normal leading-[110%] tracking-[2.2px]'>{
                                                        data.serial
                                                    }</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                <div className="w-full flex items-center justify-end mt-auto">                                    
                                    <div>
                                        <span className="text-black text-center font-pretendard text-[24px] font-medium leading-[110%]">Page {`${pageIndex + 1}/${pageCount}`}</span>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default BarcodeForm

// Rodney - 아래 테스트용으로 바코드 갯수 맞춰둔 것. 
{/* 60개 */}
{/* {
    Array.from({length : 60}).map((_, rowIndex) => {
        return (
            <div className='w-[332px] bg-[#e5e7eb] flex flex-col justify-center items-center px-[24px] py-[30px] rounded-[24px]'>
                <p className='text-[#000] text-center font-pretendard text-[48px] font-medium leading-[110%] mb-[24px]'>Discharge</p>
                <div className='mb-[12px]'>
                    <Barcode value="Discharge" format="CODE128" width={2} height={96} displayValue={false} margin={0} />
                </div>
                <p className='text-[#000] text-center font-pretendard text-[33px] font-normal leading-[110%] tracking-[2.2px]'>Discharge</p>
            </div>
        )
    })
} */}

{/* 50개 */}
{/* {
    Array.from({length : 50}).map((_, rowIndex) => {
        return (
            <div className='w-[405px] bg-[#e5e7eb] flex flex-col justify-center items-center px-[24px] py-[30px] rounded-[24px]'>
                <p className='text-[#000] text-center font-pretendard text-[48px] font-medium leading-[110%] mb-[24px]'>Discharge</p>
                <div className='mb-[12px]'>
                    <Barcode value="Discharge" format="CODE128" width={2} height={96} displayValue={false} margin={0} />
                </div>
                <p className='text-[#000] text-center font-pretendard text-[33px] font-normal leading-[110%] tracking-[2.2px]'>Discharge</p>
            </div>
        )
    })
} */}

{/* 40개 */}
{/* {
    Array.from({length : 40}).map((_, rowIndex) => {
        return (
            <div className='w-[515px] bg-[#e5e7eb] flex flex-col justify-center items-center px-[24px] py-[30px] rounded-[24px]'>
                <p className='text-[#000] text-center font-pretendard text-[48px] font-medium leading-[110%] mb-[24px]'>Discharge</p>
                <div className='mb-[12px]'>
                    <Barcode value="Discharge" format="CODE128" width={2} height={96} displayValue={false} margin={0} />
                </div>
                <p className='text-[#000] text-center font-pretendard text-[33px] font-normal leading-[110%] tracking-[2.2px]'>Discharge</p>
            </div>
        )
    })
} */}